import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main'
import checkResponse from '@/utils/checkResponse'
import parserSlug from '@/utils/parserSlug'

Vue.use(Vuex)

const state = {
  dashboard: {
    openQuotizations: {
      data: [],
      totalPages: 1
    },
    authorizedQuotizations: {
      data: [],
      totalPages: 1
    },
    incomes: 0,
    expenses: 0,
    difference: 0,
    quoted: 0,
    authorized: 0,
    areaChartData: []
  },
  purchases: {
    suppliers: [],
    projects: [],
    totalAmount: 0,
    totalQuantity: '0',
    purchaseOrders: {
      data: [],
      totalPages: 1
    },
    unitFilters: []
  },
  invoices: {
    totalHired: '0',
    currencies: [],
    balance: 0,
    customers: [],
    barChartData: {},
    payments: [],
    backUpPayments: [],
    invoices: [],
    totalPayed: 0,
    totalInvoiced: 0,
    barChartCategories: []
  }
}

const mutations = {

  SET_OPEN_QUOTIZATIONS (state, payload) {
    state.dashboard.openQuotizations.data = payload.rows
    state.dashboard.openQuotizations.totalPages = payload.pages
  },
  SET_AUTHORIZED_QUOTIZATIONS (state, payload) {
    state.dashboard.authorizedQuotizations.data = payload.rows
    state.dashboard.authorizedQuotizations.totalPages = payload.pages
  },
  SET_INCOMES (state, payload) {
    state.dashboard.incomes = payload
  },
  SET_EXPENSES (state, payload) {
    state.dashboard.expenses = payload
  },
  SET_DIFFERENCE (state, payload) {
    state.dashboard.difference = payload
  },
  SET_QUOTED (state, payload) {
    state.dashboard.quoted = payload
  },
  SET_AUTHORIZED (state, payload) {
    state.dashboard.authorized = payload
  },
  SET_AREA_CHART_DATA (state, payload) {
    var array =
        [
          {
            name: 'Cotizado',
            data: []
          },
          {
            name: 'Authorizado',
            data: []
          }
        ]

    if (payload.quoted.length <= 1) {
      array[0].data.push(payload.quoted[0] || 0)
    } else {
      array[0].data.push(...payload.quoted)
    }
    if (payload.authorized.length <= 1) {
      array[1].data.push(payload.authorized[0] || 0)
    } else {
      array[1].data.push(...payload.authorized)
    }

    state.dashboard.areaChartData = array
  },

  SET_SUPPLIERS (state, payload) {
    state.purchases.suppliers = payload
  },
  SET_PROJECTS (state, payload) {
    state.purchases.projects = payload
  },
  SET_TOTAL_AMOUNT_PURCHASE_ORDERS (state, payload) {
    state.purchases.totalAmount = payload
  },
  SET_TOTAL_QUANTITY_PURCHASE_ORDERS (state, payload) {
    state.purchases.totalQuantity = payload
  },
  SET_PURCHASE_ORDERS (state, payload) {
    state.purchases.purchaseOrders.data = payload.rows
    state.purchases.purchaseOrders.totalPages = payload.pages
  },
  SET_FILTERS (state, payload) {
    const units = payload.rows.map(item => item.unit_of_measurement)
    const distinctUnits = [...new Set(units)]
    state.purchases.unitFilters = distinctUnits
  },

  SET_CUSTOMERS (state, payload) {
    state.invoices.customers = payload
  },
  SET_CURRENCIES (state, payload) {
    state.invoices.currencies = payload
  },
  SET_BAR_CHART_DATA (state, payload) {
    var array =
        [
          {
            name: 'Facturado',
            data: []
          },
          {
            name: 'Pagado',
            data: []
          }
        ]

    if (payload.invoices.length) {
      payload.invoices.forEach((index) => {
        array[0].data.push(index.amount)
        array[1].data.push(index.total_payed)
      })
    }

    state.invoices.barChartCategories = payload.invoices.map((value, index) => index + 1)

    state.invoices.barChartData = array
  },
  SET_PAYMENTS (state, payload) {
    state.invoices.payments = payload
  },
  FORMAT_ALL_INVOICES_DATA (state, payload) {
    state.invoices.totalHired = payload.total_hired
    state.invoices.balance = payload.balance
    state.invoices.totalPayed = payload.total_payed
    state.invoices.totalInvoiced = payload.total_invoiced

    state.invoices.invoices = payload.invoices
    state.invoices.payments = payload.payments
    state.invoices.backUpPayments = payload.payments
  }

}

const actions = {

  async loadGeneralDashboardData ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`quotations/generalDashboardData?${payload.date ? 'date=' + payload.date : ''}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_EXPENSES', response.data.expenses)
        commit('SET_INCOMES', response.data.incomes)
        commit('SET_QUOTED', response.data.quoted)
        commit('SET_AUTHORIZED', response.data.authorized)
        commit('SET_DIFFERENCE', response.data.incomes - response.data.expenses)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: 'error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadDashboardAreaChart ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`quotations/dashboardAreaChart?${payload.date ? 'date=' + payload.date : ''}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_AREA_CHART_DATA', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: 'error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadDashboardTablesData ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`quotations/dashboardTablesData?page=${payload.page}${payload.filters}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: checkErrors.message }, { root: true })
      } else {
        if (payload.status === 1) {
          commit('SET_OPEN_QUOTIZATIONS', response.data)
        } else {
          commit('SET_AUTHORIZED_QUOTIZATIONS', response.data)
        }
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'Error', text: 'Load Dashboard Tables Data' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },

  async loadPurchaseOrdersCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        if (payload.url === 'suppliers') commit('SET_SUPPLIERS', response.data.data)
        else if (payload.url === 'projects') commit('SET_PROJECTS', response.data.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadSuppliesIds ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`purchase-orders/suppliesIds?${payload.filters}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: checkErrors.message }, { root: true })
      } else {
        return response.data
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'Error', text: 'Load Dashboard Tables Data' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadTotalAmountPurchaseOrders ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`purchase-orders/totalAmountPurchaseOrders?${payload.filters}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_TOTAL_AMOUNT_PURCHASE_ORDERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'Error', text: 'Load Dashboard Tables Data' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setTotalAmount ({ commit }, amount) {
    commit('SET_TOTAL_AMOUNT_PURCHASE_ORDERS', amount)
  },
  setTotalQuantity ({ commit }, quantity) {
    commit('SET_TOTAL_QUANTITY_PURCHASE_ORDERS', quantity)
  },
  clearPurchaseOrdersTable ({ commit }, payload) {
    commit('SET_PURCHASE_ORDERS', { rows: [], totalPages: 0 })
  },
  async loadSupplies ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`supplies/dashboardTableData?page=${payload.page}${payload.filters}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PURCHASE_ORDERS', response.data)
        commit('SET_FILTERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'Error', text: 'Load Dashboard Tables Data' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },

  async loadCustomers ({ commit }, payload) {
    try {
      const response = await axios.get(`customers${payload.filter}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CUSTOMERS', response.data.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadCurrencies ({ commit }, payload) {
    try {
      const response = await axios.get(`currencies`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CURRENCIES', response.data.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadAllInvoicesData ({ commit }, payload) {
    try {
      const response = await axios.get(`projects/${payload.customer_id}/dashboardData?&currency_id=${payload.currency_id}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('FORMAT_ALL_INVOICES_DATA', response.data)
        commit('SET_BAR_CHART_DATA', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'Error', text: 'Load All invoices data' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  filterByInvoiced ({ commit }, invoice) {
    commit('SET_BAR_CHART_DATA', { invoices: [invoice] })
    const filterPayments = state.invoices.backUpPayments.filter((value) => {
      if (value.invoice_id === invoice.id) return value
    })
    commit('SET_PAYMENTS', filterPayments)
  }

}

const getters = {
  dashboard: state => state.dashboard,
  purchases: state => state.purchases,
  invoices: state => state.invoices
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
